import React from 'react';
import {Link, useNavigate} from 'react-router-dom';

const IngredientsPage = () => {
  const navigate = useNavigate();
  const checkboxImagePath = '/images/IngredientsCheckB.png'; // Path to checkbox image
  const backgroundImagePath = '/images/Cabonara.png'; // Path to your background image

  const handleImageClick = () => {
    alert('Image clicked!');
    // Add your desired functionality here
  };

  return (
    <div className="bg-[#1a1a1a] text-white h-full w-full flex flex-col items-center justify-center">
        <img
          src={backgroundImagePath}
          className="absolute inset-0 w-full h-full object-cover opacity-50 z-0 filter"
        />

      <div className="absolute inset-0 z-1 bg-opacity-20 bg-milky backdrop-blur rounded-lg w-full h-full text-white">
          <div className="m-auto flex flex-col justify-center items-center text-white p-6 w-full min-h-full h-screen md:w-1/2">
              <div>
                  <div className="px-6 mt-4 flex flex-col font-extrabold">
                      <h1 className="text-3xl font-extrabold my-6">Ingredients</h1>
                  </div>
                  <ul className="text-xl text-white z-10">
                      <li className="px-6 mb-4 flex items-center justify-between">
                          350 g of spaghetti
                          <Link to="/products-page">
                              <img src={checkboxImagePath} alt="Checkbox" className="w-7 h-7" />
                          </Link>
                      </li>
                      <li className="px-6 mb-4 flex items-center justify-between">
                          200 g of guanciale
                          <Link to="/products-page">
                              <img src={checkboxImagePath} alt="Checkbox" className="w-7 h-7" />
                          </Link>
                      </li>
                      <li className="px-6 mb-4 flex items-center justify-between">
                          4 whole medium eggs
                          <Link to="/products-page">
                              <img src={checkboxImagePath} alt="Checkbox" className="w-7 h-7" />
                          </Link>
                      </li>
                      <li className="px-6 mb-4 flex items-center justify-between">
                          Grated Pecorino Romano
                          <Link to="/products-page">
                              <img src={checkboxImagePath} alt="Checkbox" className="w-7 h-7" />
                          </Link>
                      </li>
                      <li className="px-6 mb-4 flex items-center justify-between">
                          Ground black pepper
                          <Link to="/products-page">
                              <img src={checkboxImagePath} alt="Checkbox" className="w-7 h-7" />
                          </Link>
                      </li>
                  </ul>
              </div>
              <div className="flex justify-center items-center flex-col md:justify-start pb-2">
                  <button
                      className="py-2 my-10 md:my-3 bg-orange-600 hover:bg-orange-500 text-white px-8 rounded-full text-lg w-3/4 md:w-64 md:text-xl font-bold"
                      onClick={() => {
                          navigate('/cook');
                      }}
                  >
                      Ready
                  </button>
              </div>
          </div>
          </div>
    </div>
  );
};

export default IngredientsPage;
